import { measureTextWidth } from "@ant-design/plots";
import AdnPie from "../common/adnPie/AdnPie";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const OffersDashboard = ({ offerTypeData }) => {
  const { t } = useTranslation();

  const offerTypesconfig = {
    data: offerTypeData ? offerTypeData.offerTypesStatistic : [],
    angleField: "quantityOffered",
    colorField: "offerTypeName",
    color: ["#0A2038", "#005888", "#77CEFF"],
    radius: 1,
    innerRadius: 0.64,
    interactions: [
      {
        type: "element-active",
        cfg: {
          showEnable: [
            { trigger: "element:mouseenter", action: "cursor:pointer" },
            { trigger: "element:mouseleave", action: "cursor:default" },
          ],
        },
      },
      {
        type: "element-selected",
      },
      {
        type: "pie-statistic-active",
      },
    ],
    meta: {
      value: {
        formatter: (v) => `${v}`,
      },
    },
    label: {
      type: "inner",
      offset: "-40%",
      autoHide: true,
      autoRotate: false,
      content: "{value}",
      style: {
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    statistic: {
      title: {
        style: {
          marginLeft: "-3px",
        },
        offsetY: -8,
        customHtml: (container, view, datum) => {
          if (offerTypeData) {
            const { width, height } = container.getBoundingClientRect();
            const d = Math.sqrt(
              Math.pow(width / 2, 2) + Math.pow(height / 2, 2)
            );
            const text = datum ? datum.offerTypeName : t("offersDashboard.all");
            return renderStatistic(d, text, {
              fontSize: 16,
            });
          }
        },
      },
      content: {
        offsetY: -4,
        style: {
          fontSize: "22px",
        },
        customHtml: (container, view, datum, data) => {
          if (offerTypeData) {
            const { width } = container.getBoundingClientRect();
            const text = datum
              ? `${datum.quantityOffered > 0 ? datum.quantityOffered : 0} ${t(
                  "offersDashboard.outOf"
                )} ${datum.totalQuantity ? datum.totalQuantity : 0}`
              : `${data.reduce((r, d) => r + d.quantityOffered, 0)} ${t(
                  "offersDashboard.outOf"
                )} ${data.reduce((r, d) => r + d.totalQuantity, 0)}`;
            return renderStatistic(width, text, {
              fontSize: 16,
            });
          }
        },
      },
    },
  };

  function renderStatistic(containerWidth, text, style) {
    const { width: textWidth, height: textHeight } = measureTextWidth(
      text,
      style
    );
    const R = containerWidth / 2;

    let scale = 1;

    if (containerWidth < textWidth) {
      scale = Math.min(
        Math.sqrt(
          Math.abs(
            Math.pow(R, 2) /
              (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2))
          )
        ),
        1
      );
    }

    const textStyleStr = `width:${containerWidth}px;`;
    return `<div style="${textStyleStr};font-size:${scale}em;line-height:${
      scale < 1 ? 1 : "inherit"
    };padding:0.5rem;">
              ${text}
            </div>`;
  }

  const navigate = useNavigate();

  return <AdnPie offerTypesconfig={offerTypesconfig} navigate={navigate} />;
};

export default OffersDashboard;
